<template>
  <div id="app">
    <TopNav/>
    <router-view/>
  </div>
</template>

<script>
import TopNav from "./components/TopNav";
export default {
  name: 'App',
    components: {TopNav}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width:100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue